import { Component, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { collection, doc, Firestore, getDoc, getDocs, orderBy, query, setDoc, updateDoc, where, arrayUnion } from '@angular/fire/firestore';

@Component({
  selector: 'app-mainpage',
  imports: [
    RouterModule
  ],
  templateUrl: './mainpage.component.html',
  styleUrl: './mainpage.component.css'
})
export class MainpageComponent {
  // private readonly firestore = inject(Firestore);
  
  constructor(
    private router: Router,


  ) {
    // getDocs(collection(this.firestore,'users')).then((dataa)=>{
    //   for (let i = 0; i < dataa.docs.length; i++) {
    //     const element = dataa.docs[i];
    //     const elemeentdata = element.data()
    //     console.log(elemeentdata,"element console");
    //   }
    // })
  }

  goToHome() {
    // this.router.navigate(['/home']);
  }
}
